<template>
  <div>
    <div class="page-header">
		<div class="add-item d-flex">
			<div class="page-title">
				<h4>{{ $t('customer_due') }}</h4>
			</div>
		</div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--      </li>-->
<!--		</ul>-->
		<div class="page-btn">
      <router-link to="/customer/head/create" class="btn btn-added">
        <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_customer_due") }}
      </router-link>
		</div>
	</div>
	<!-- /product list -->
	<div class="card table-list-card">
		<div class="card-body">
			<div class="table-responsive">
				<DataTable v-if="sub_categories.length" :tableId="'subCategoryTable'">
					<thead>
						<tr>
							<th>{{ $t('node') }}</th>
							<th>{{ $t('customer_name') }}</th>
							<th class="no-sort">{{ $t('action') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="sub_category in sub_categories" :key="sub_category.id">
							<td>{{ sub_category.parent_category }}</td>
							<td>{{ sub_category.node }}</td>
							<td class="action-table-data">
							<div class="edit-delete-action">
								<a class="me-2 p-2" href="#" @click.prevent="openEditModal(sub_category)">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ti ti-edit">
										<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
									</svg>
								</a>
							</div>
							</td>
						</tr>
					</tbody>
				</DataTable>
        <!-- If No Data -->
        <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <h5 class="text-muted">No Data Found</h5>
          <p class="text-secondary small">Try adjusting filters or add new data.</p>
        </div>

				<EditModal :categories="categories" :selectedSubCategory="selectedSubCategory" @edit_success="fetchSubCategories" />
			</div>
		</div>
	</div>
<!-- /product list -->

  </div>
</template>

<script>
import EditModal from '@/views/admin_dashboard/customer_head/EditModal.vue';
import DataTable from '@/components/common/DataTable.vue';
import apiUrls from '@/urls';

export default {
  inject: ['globalLoading'],
  components: {
    EditModal,
    DataTable,
  },
  data() {
    return {
      sub_categories: [],
      selectedSubCategory: {},
      categories: [],
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get(apiUrls.customer_head.get);
        this.categories = response.data;
      } catch (error) {
        console.error("Error fetching categories:", error);
        this.errorMessage = "Unable to load categories.";
      }
    },
    openEditModal(sub_category) {
        this.selectedSubCategory = sub_category;
        this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('edit-modal'));
        modal.show();
      });
    },
    async fetchSubCategories() {
      this.globalLoading(true)
      try {
        const response = await this.$axios.get(apiUrls.customer_sub_head.get);
        this.sub_categories = response.data;
      } catch (error) {
        console.error("Error fetching sub categories:", error);
      } finally {
        this.globalLoading(false)
      }
    },
  },

  created() {
	  this.fetchCategories();
    this.fetchSubCategories();
  },
};
</script>
